
export default {
  blocksSpec: [
    {
      title: 'What you’ll do:',
      id: 'dailyTasks',
    },
    {
      title: 'What we’re looking for:',
      id: 'requirements',
    },
    {
      title: 'What will impress us:',
      id: 'impressUs',
    },
  ],

  getInTouch: {
    title: 'Interested?',
    content: 'Email your English CV and a brief description of your career goals to careers@iteriodata.com. Please put "#{position_name}" in the subject and feel free to send us links to your Github, portfolio, or whatever you feel is important for us to learn more about you. We look forward to hearing from you.',
  },
};



// WEBPACK FOOTER //
// ./src/config/offer.js